module.exports = __webpack_public_path__ + "static/media/earth.e1278e27.png";